import { makeAutoObservable } from 'mobx';
import { ChannelGroupsEnum, ChannelNamesEnum, IChannel, IChannelGroup } from '../interfaces';

export class CommunicationChannel implements IChannel {
  constructor(public name: ChannelNamesEnum, public groups: Record<ChannelGroupsEnum, IChannelGroup>) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public static new(...args: ConstructorParameters<typeof CommunicationChannel>) {
    return new CommunicationChannel(args[0], args[1]);
  }

  copyActual() {
    for (const group of Object.values(this.groups)) {
      group.initial = group.isEnabled;
    }
  }

  flip(groupName: ChannelGroupsEnum) {
    if (this.groups[groupName]) {
      this.groups[groupName].isEnabled = !this.groups[groupName].isEnabled;
    }
  }

  isChanged(groupName: ChannelGroupsEnum) {
    return this.groups[groupName].isEnabled !== this.groups[groupName].initial;
  }

  disable(groupName: ChannelGroupsEnum) {
    if (this.groups[groupName]) {
      this.groups[groupName].isEnabled = false;
      this.groups[groupName].initial = false;
    }
  }
}
